// Pure label-builder for the "Select Date" dropdown, split out from index.jsx
// so the location-suffix logic (Shoob studio vs. on-location school) can be
// unit-tested without mounting the React component.
import { isShoobDayKey, stripShoobDaySuffix } from './shoob-day'

const MONTHS = [
  'January',
  'February',
  'March',
  'April',
  'May',
  'June',
  'July',
  'August',
  'September',
  'October',
  'November',
  'December',
]

const SHOOB_STUDIO_NAME = 'Shoob Photo Studio'

// Shoob-studio days always show the studio name. On-location (school) days
// used to show no location at all -- only the bare date -- which read as if
// every date were at the studio. Show the school's name when we have one.
const dayOptionLabel = (day, school) => {
  const date = new Date(Date.parse(`${stripShoobDaySuffix(day)}T12:00:00`))
  const locationName = isShoobDayKey(day) ? SHOOB_STUDIO_NAME : (school && school.name)
  const suffix = locationName ? ` @ ${locationName}` : ''

  return `${MONTHS[date.getMonth()]}, ${date.getUTCDate()}${suffix}`
}

export default dayOptionLabel
